module.exports = fox._r("fonts/throughChat.eot?exnqbq", __webpack_public_path__ + "_/_/_/root/fonts/jG_130I.eot");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/throughChat.eot?exnqbq
// module id = 52
// module chunks = 4